<div class="snackbar-content" [class.success]="data.type === 'success'" [class.error]="data.type === 'error'">
    <div class="snackbar-body">
        <span matSnackBarLabel class="snackbar-message">{{data.message}}</span>
    </div>
    <div class="progress-bar-container" aria-hidden="true">
            <div class="progress-bar" [style.width.%]="progress"></div>
    </div>
</div>